$(document).ready(function() {
	$('.main-menu-values .icon-close').click(function() {
		$('.main-menu-values').hide();
		setTimeout(function() {
			var headerHeight = $('.header__wrapper').height(); 
	    	$('#MainContent').css({'padding-top': headerHeight + 'px' });
		}, 50);
	});

	$(window).resize(function() {
		setTimeout(function() {
			var headerHeight = $('.header__wrapper').height(); 
	    	$('#MainContent').css({'padding-top': headerHeight + 'px' });
		}, 50);
	});

	setTimeout(function() {
		var headerHeight = $('.header__wrapper').height(); 
    	$('#MainContent').css({'padding-top': headerHeight + 'px' });
	}, 50);

	$('.sf-menu-close').click(function() {
		$('.sf-menu-wrapper-mobile').click();
	});

	$('.prod__sizechart').click(function() {
		$('.prod__sizechart-modal, .overlay').show();
		$('body, html').css({'overflow': 'hidden'});
	});

	$('.overlay, .prod__sizechart-modal .icon-close').click(function() {
		$('.prod__sizechart-modal, .overlay').hide();
		$('body, html').css({'overflow': 'initial'});
	});

	$(document).on('click', '.p-info-btn', function() {
		$(this).toggleClass('open');
		$('.p-info').toggleClass('open');
	});
});